'use strict';
import React from 'react';
class HeaderMenuNavComponentTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth
        };
    }

    componentDidMount() {
        let self = this;
        window.addEventListener('resize', this.handleResize);
        this.setupSellButtonListener();
        //console.log(this.props)

        if (document.body.classList.contains('page-home')) {
            setTimeout(function() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                if (window.location.href.includes('#rentals')) {
                    self.scrollToSectionWithPadding('rentals');
                }

                if (window.location.href.includes('#services')) {
                    self.scrollToSectionWithPadding('services');
                }
            }, 500);
        }
    }

    scrollToSectionWithPadding(sectionId) {
        var targetSection = document.getElementById(sectionId);
        let headerHeight = 150;
        var offsetTop = targetSection.offsetTop - headerHeight;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }

    setupSellButtonListener() {
        const sellButtons = document.querySelectorAll('.sell-button');

        if (sellButtons) {
            sellButtons.forEach(sellButton => {
                sellButton.removeAttribute('href');

                sellButton.addEventListener('click', e => {
                    if (this.props.user === 'undefined') {
                        let loc = (location.pathname + location.search).substr(1);
                        location.href = `/accounts/non-private/sign-in?returnUrl=merchants/upload`;
                        return;
                    } else {
                        window.location.replace('/merchants/upload');
                    }
                });
            });
        }
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.handleResize);
    }

    // handleResize = () => {
    //     this.setState({ windowWidth: window.innerWidth });
    // }

    render() {
        const isMobileClassName = this.props.isMobile ? 'mobile-only' : '';
        const isUserLoggedIn = this.props.user && this.props.user.Guest === false;
        const isHomepageRent = document.body.classList.contains('page-home') ? 'javascript:void(0)' : '/#rentals';
        const isHomepageService = document.body.classList.contains('page-home') ? 'javascript:void(0)' : '/#services';

        return (
            <>
                {/* <li key="navi-buy" className={isMobileClassName}><a id='homepageRent' href={isHomepageRent}>Rent Equipment</a></li> */}
                <li key='navi-sell' className={isMobileClassName}>
                    <a id='homepageService' href='/search'>
                        Find a tasker
                    </a>
                </li>
                <li key='navi-resources' className={isMobileClassName}>
                    <a href='/pages/Service-provider'>Provide A Task</a>
                </li>
                <li key='navi-about' className={isMobileClassName}>
                    <a href='/pages/about'>About</a>
                </li>
                <li key='navi-faq' className={isMobileClassName}>
                    <a href='#'>FAQ</a>
                </li>
                {/* {isUserLoggedIn && <li key="navi-reffer" className={isMobileClassName}><a href="/pages/refer-a-friend">Refer a Friend</a></li>} */}
                {/* <li key="navi-reffer" className={isMobileClassName}><a href="/pages/refer-a-friend">Refer a Friend</a></li> */}
                <li key='navi-contact' className={isMobileClassName}>
                    <a href='https://www.bcaa.com/bcaa-marketplace/task-marketplace/contact-us'>Contact Us</a>
                </li>
            </>
        );
    }
}

export default HeaderMenuNavComponentTemplate;
